<script>
import emailLayoutForm from "@/views/menu/configurations/emails/layouts/emailLayoutForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    emailService: "emailService",
    toastService: "toastService"
  },
})
export default class EmailLayoutNew extends mixins(emailLayoutForm) {
  formId = "new-email-layout-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        handle: this.save,
      },
    ];
  }

  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
        await this.emailService.createLayout(this.model);
      this.$router.push("/configurations/emails/list/layouts");
      this.toastService.success(this.translations.success.emailLayout_create);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle() {
    return this.translations.pageTitles.emailLayouts_new;
  }

  afterCreate() {
    this.model = {
      code: null,
      idLanguage: null,
      contents: null
    };
    this.isReady = true;
  }
}
</script>
